import { lazy } from 'react';
import { type RouteObject } from 'react-router-dom';

import { MATHQUIZ_ROUTES as MATHQUIZ_ROUTE_CONSTANTS } from '../../route-constants';

const MathQuizReportPage = lazy(
  () => import('@~/pages/mathfit-quiz-report/mathfit-quiz-report'),
);

export const MATHQUIZ_ROUTES: RouteObject[] = [
  {
    path: MATHQUIZ_ROUTE_CONSTANTS.REPORT.PATH,
    element: <MathQuizReportPage />,
    handle: {
      pageName: MATHQUIZ_ROUTE_CONSTANTS.REPORT.NAME,
    },
  },
];
